import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  confirmPasswordReset,
  validatePasswordResetToken,
} from "../api/authPasswordApi";
import PasswordSetupForm from "../components/auth/PasswordSetupForm";

const INVALID_LINK_MESSAGE = "This link is invalid or has expired.";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [loading, setLoading] = useState(Boolean(token));
  const [valid, setValid] = useState(false);
  const [accountEmail, setAccountEmail] = useState("");
  const [accountName, setAccountName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setErrorMessage(INVALID_LINK_MESSAGE);
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const body = await validatePasswordResetToken(token);
        if (!cancelled) {
          setValid(Boolean(body?.success));
          setAccountEmail(body?.email || "");
          setAccountName(body?.displayName || "");
        }
      } catch {
        if (!cancelled) {
          setValid(false);
          setErrorMessage(INVALID_LINK_MESSAGE);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token || (!loading && !valid)) {
    return (
      <div className="midpoint-app auth-page">
        <div className="auth-login-card panel-card">
          <p className="eyebrow">Midpoint</p>
          <h1>Reset password</h1>
          <p className="auth-login-error" role="alert">
            {errorMessage || INVALID_LINK_MESSAGE}
          </p>
          <p className="muted auth-login-footnote">
            <Link to="/forgot-password">Request a new reset link</Link>
            {" · "}
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="midpoint-app auth-page">
        <div className="auth-login-card panel-card">
          <p className="muted">Checking your reset link…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="midpoint-app auth-page">
      <PasswordSetupForm
        title="Reset password"
        description="Choose a new password for your Midpoint account."
        accountEmail={accountEmail}
        accountName={accountName}
        submitLabel="Reset password"
        onSubmit={(password) => confirmPasswordReset(token, password)}
      />
      <p className="muted auth-login-footnote" style={{ textAlign: "center", marginTop: "1rem" }}>
        <Link to="/login">Back to sign in</Link>
      </p>
    </div>
  );
};

export default ResetPasswordPage;
